const get_data_customTable = async (customTable) => {
    let obj = {};
    let array = [];
    try {
        // se debe consultar por el nombre para encontrar el id 
        const resId = await axios.get(`/admin/app/custom-table/serverside/id/${customTable}`);
        if (resId.data.id) {
            const response = await axios.get(`/admin/app/custom-table/values/${resId.data.id}`);
            const dataRes = response.data.data;     
            for (let index = 0; index < dataRes.length; index++) {
                const element = dataRes[index]['field_values'];
                for (let y = 0; y < element.length; y++) {
                    if (y == 0) {
                        obj = {'id' : element[y]['id'], 'value' : element[y]['value']};
                        array.push(obj);
                    }   
                }
            }
            return array;
        } 
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const update_data = async (inputs) => {
    const rowId = inputs.id;
    const response = await axios.patch(
        `/costingResources/${rowId}`,
        inputs,
    );
    return response;
}  

const delete_cost = async (id) => {
    const response = await axios.delete(`/costingResources/${id}`);
    return response;
}

const validateCostBeforeConvert = async (ids, $toastr) => {
    const res = await axios.post('/costing/bulk-send', { cost_ids: ids })
        .then(response => {
            const {data} = response;
            if (data.status === 'error') {
                $toastr.w(data.message);
                return false;
            }
            return true;
        })
        .catch(error => {
            this.$toastr.e('An error occurred while sending records.');
        });
    return res;
}

const get_data_cost = async (id) => {
    try {
        const response = await axios.get(`/costingResources/${id}`);                 
        const res = JSON.parse(JSON.stringify(response.data));
        if (res) {
            const supplier = res.supplier;
            const country = res.country;
            const product = res.product;
            const customer = res.customer;
            // tener en cuenta que las custom table siempre tiene la estructura id, value
            let obj = {
                "id"                                : id,
                "cost_type"                         : res.cost_type,
                "quantity"                          : res.quantity,
                "shipping"                          : res.shipping ?? '',
                "other"                             : res.other ?? '',
                "comment"                           : res.comment ?? '',
                "supplier"                          : { id : supplier.id,  Title : supplier.Second_Title, BillAddress : supplier.BillAddress, city : null, state : null, country : null, secondTitle : null, address : null, }, 
                "costPerFob"                        : { data : res.costperfob_data ?? '', value : res.costperfob_value },
                "country"                           : { id: country.id, name: country.name, Code: country.Code, }, 
                "product"                           : { id: product.id, name: product.name, }, 
                "category"                          : { id: res?.category?.id, name: res?.category?.name},
                "purchaseComission"                 : { 
                                                        data : res.purchasecomission_data ?? 0, 
                                                        unit : {
                                                            id: res.purchasecomission_unit_id ?? '', 
                                                            code: res.purchasecomission_unit_code ?? '', 
                                                            factor: res.purchasecomission_unit_factor
                                                        },
                                                        value : res.purchasecomission_value ?? 0, },
                "product_crop"                      : { id: res.product_crop_id ?? '',  value: res.product_crop_value ?? '' },
                "product_org_conv"                  : { id: res.product_org_conv_id ?? '',  value: res.product_org_conv_value ?? '' },
                "product_subcategory"               : { id: res.product_subcategory_id ?? '',  value: res.product_subcategory_value ?? '' },
                "product_feature"                   : { id: res.product_feature_id ?? '',  value: res.product_feature_value ?? '' },
                "product_cutsize"                   : { id: res.product_cutsize_id ?? '',  value: res.product_cutsize_value ?? '' },
                "product_grade"                     : { id: res.product_grade_id ?? '',  value: res.product_grade_value ?? '' },
                "inspection"                        : { data : res.inspection_data ?? '',  value : res.inspection_value ?? '', },
                "payloadLbs"                        : { data : res.payloadlbs_data ?? '', dataTotal : res.payloadlbs_data * res.quantity },
                "price"                             : { 
                                                        currency : {
                                                            id : res.price_currency_id,
                                                            Code : res.price_currency_code
                                                        }, 
                                                        value : res.price_value ?? '', 
                                                        unit : {
                                                            id: res.price_unit_id ?? '', 
                                                            code: res.price_unit_code ?? '',
                                                            factor: res.price_unit_factor ?? ''
                                                        } 
                                                    },
                "bankCharges"                       : { data : res.bankcharges_data ?? '', value : res.bankcharges_value ?? '',  },
                "oceanDestination"                  : { data : res.oceandestination_data ?? '', value : res.oceandestination_value ?? '', },
                "inlandFreight"                     : { data : res.inlandfreight_data ?? '', value : res.inlandfreight_value ?? '', },
                "productPack"                       : { pack : {id: res.productpack_pack_id ?? '',  value: res.productpack_pack_value ?? ''}, quantity : res.productpack_quantity ?? ''},
                "productSize"                       : { 
                                                        size : {
                                                            id: res.productsize_size_id ?? '',  
                                                            code : res.productsize_size_code ?? '',
                                                            factor: res.productsize_size_factor ?? ''}, 
                                                        quantity : res.productsize_quantity},
                "productIncoterm"                   : { id: res.productincoterm_id ?? '',  value: res.productincoterm_value ?? '', },
                "customerIncoterm"                  : { id : res.customer_incoterm_id ?? '', value : res.customer_incoterm_value},
                "warehousesCharges"                 : { data: res.warehousescharges_data ?? '',  value: res.warehousescharges_value ?? '',},
                "customsBrokerage"                  : { data : res.customsbrokerage_data, value : res.customsbrokerage_value,},
                "rateDuty"                          : { data : res.rateduty_data ?? '', value : res.rateduty_value ?? '', },
                "payment"                           : { id: res.payment_id ?? '',  value: res.payment_value ?? '', },
                "rateTariff"                        : { data : res.ratetariff_data ?? '', value : res.ratetariff_value ?? '', },
                "herborMaintenence"                 : { data : res.herbormaintenence_data ?? '', value : res.herbormaintenence_value, },
                "cvForduties"                       : { value : res.cvforduties_value ?? '',},
                "merchandiseProcessing"             : { data : res.merchandiseprocessing_data ?? '', value : res.merchandiseprocessing_value ?? '',},
                "cvForTariff"                       : { value : res.cvfortariff_value ?? '', },
                "insurance"                         : { data : res.insurance_data ?? '', value : res.insurance_value ?? '', factor : res.insurance_factor, },
                "otherCost"                         : { 
                                                        data : res.othercost_data ?? '', 
                                                        unit : {
                                                            id: res.othercost_unit_id, 
                                                            code: res.othercost_unit_code, 
                                                            factor: res.othercost_unit_factor
                                                        },
                                                        value : res.othercost_value ?? '', },
                "cost"                              : { value : res.cost_value ?? 0 },
                "commisionSales"                    : { data : res.commisionsales_data ?? '', value : res.commisionsales_value ?? '',},
                "totalCost"                         : { value: res.totalcost_value ?? 0 },
                "toConvert"                         :  
                                                    { 
                                                        unit: 
                                                        {   id:res.toconvert_unit_id ?? '', 
                                                            code:res.toconvert_unit_code ?? '',
                                                            factor : res.toconvert_unit_factor ?? ''
                                                        },  
                                                        value : res.toconvert_value ?? '', 
                                                    }, 
                "customer"                          : { id: customer.id ?? '', Title: customer.Second_Title, cityName: null, stateName: null, countryName: null, PostalZipCode : null },  
                "priceTerms"                        : { 
                                                        currency : {
                                                            id: res.priceterms_currency_id ?? '', 
                                                            Code : res.priceterms_currency_code ?? ''
                                                        },  
                                                        unit : {
                                                            id: res.priceterms_unit_id, 
                                                            code: res.priceterms_unit_code, 
                                                            factor: res.priceterms_unit_factor 
                                                        }, 
                                                        value : res.priceterms_value ?? '',} ,
                "customBrokerageFinalDestination"   : { data : res.custombrokeragefinaldestination_data ?? '', value : res.custombrokeragefinaldestination_value ?? ''} ,
                "selectedfinalDestination"          : res.final_destination_id ?? '',
                "descriptionFinalDestination"       : res.final_destination_value ?? '',
                "herbormaintenence_settings_factor" : res.herbormaintenence_settings_factor,
                "merchandiseprocessing_settings_factor" : res.merchandiseprocessing_settings_factor,
                "insurance_settings_factor"         : res.insurance_settings_factor,
            }
            return obj;         
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
        return false;
    } 
}

const get_ship_address_customer = async (id) => {
    try {
        const response = await axios.get(`/companies_customer/serverside/ship_address/${id}`);
        return response.data.data;
   } catch (error) {
        console.error('Error al obtener los detalles del proveedor:', error);
   }
}

const contactAddress = (selectedAddress) => {
    let linesWithBreaks = [];

    if (selectedAddress?.name) {linesWithBreaks.push(selectedAddress.name + ',' );}
    if (selectedAddress?.address) {linesWithBreaks.push(selectedAddress.address + ',');}
    if (selectedAddress?.city_name) {linesWithBreaks.push(selectedAddress.city_name + ',');}

    let stateCountryLine = [];
    if (selectedAddress?.state_name) {stateCountryLine.push(selectedAddress.state_name + ', '); }
    if (selectedAddress?.country_name) {stateCountryLine.push(selectedAddress.country_name + ', ');}
    if (selectedAddress?.zipCode) {stateCountryLine.push(selectedAddress.zipCode);}
    
    if (stateCountryLine.length > 0) {
        linesWithBreaks.push(stateCountryLine.join(' '));
    }
    return linesWithBreaks;
} 

export { get_data_customTable, get_data_cost, update_data, delete_cost, get_ship_address_customer, contactAddress, validateCostBeforeConvert };